import { render, staticRenderFns } from "./DashboardChartPatients.vue?vue&type=template&id=9a69a0ce&scoped=true&"
import script from "./DashboardChartPatients.vue?vue&type=script&lang=js&"
export * from "./DashboardChartPatients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a69a0ce",
  null
  
)

export default component.exports